<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800" v-if="!isEdit">Crear Pregunta</h1>
      <h1 class="h3 mb-2 text-gray-800" v-if="isEdit">Editar Pregunta</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="card-body">
          <b-form
            @submit="onSubmit"
            @reset="onReset"
            v-if="show"
            autocomplete="on"
          >
            <div class="row">
              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Categoría:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.category"
                    :options="categories"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Subcategoría:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.subcategory"
                    :options="subcategories"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Tipo de pensamiento:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.knowledgeArea"
                    :options="knowledge_areas"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Competencia:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.competencies"
                    :options="competencies"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Dificultad:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.difficulty"
                    :options="difficulties"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  id="input-group-type"
                  label="Tipo de pregunta:"
                  label-for="input-type"
                >
                  <b-form-select
                    id="input-type"
                    v-model="form.questionType"
                    :options="questionTypeOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>

            <hr />
            <b-form-group
              v-if="isEdit"
              id="input-group-1"
              label="Código único"
              label-for="input-1"
            >
              <b-form-input
                v-model="form.uniqueName"
                placeholder=""
                required
                readonly
              ></b-form-input>
            </b-form-group>

            <hr />

            <div class="container mt-5" v-if="isEdit">
              <div class="div-lessons">
                <h3>Tags</h3>
                <button
                  class="btn btn-primary"
                  @click="showModal1()"
                  type="button"
                >
                  <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar
                  tags
                </button>
              </div>

              <br />
              <br />

              <table class="table">
                <thead>
                  <tr>
                    <th>Titulo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-for="tag in tags" :key="tag.id">
                  <tr>
                    <td>{{ tag.name }}</td>

                    <td>
                      <button
                        class="btn btn-secondary"
                        v-on:click="deleteTag(tag.id)"
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="tags && tags.length === 0">
                  <tr>
                    <td colspan="2" class="td-nhd">No hay datos</td>
                  </tr>
                </tbody>
              </table>

              <b-modal
                no-close-on-backdrop
                ref="my-modal2"
                size="xl"
                hide-footer
                title="Tags"
                v-on:hide="onModalHide"
              >
                <div class="lessons-model">
                  <b-input-group>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Crear o buscar tag"
                      aria-label="Search"
                      aria-describedby="basic-addon2"
                      v-model="searchTags"
                      v-on:keyup="loadTags"
                    />
                    <b-input-group-append>
                      <b-button variant="info" v-on:click="createTag"
                        >Crear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>

                <div class="lessons-model">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-for="(tag, index) in tagsitems" :key="index">
                      <tr>
                        <td>{{ tag.name }}</td>
                        <td>
                          <div
                            class="col col-sm-6 col-md-6 col-lg-6 text-center"
                          >
                            <b-button
                              class="mt-3"
                              variant="outline-danger"
                              v-on:click="saveTag(tag.id)"
                              block
                              >Agregar</b-button
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-if="tags && tags.length === 0">
                      <tr>
                        <td colspan="2" class="td-nhd">No hay datos</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-modal>
            </div>
            <hr />

            <b-form-group
              id="input-group-1"
              label="Pregunta"
              label-for="input-1"
              description="Vista previa con MathJax"
            >
              <b-form-textarea
                id="textarea"
                v-model="form.description"
                placeholder=""
                rows="9"
                max-rows="16"
                required
              ></b-form-textarea>
              <hr />
              <p id="description"></p>
            </b-form-group>
            <br />

            <b-form-group
              v-if="form.questionType !== 'OPEN_ENDED'"
              id="input-group-1"
              label="Solución"
              label-for="input-1"
              description="Vista previa con MathJax"
            >
              <b-form-textarea
                id="textarea"
                v-model="form.solution"
                placeholder=""
                rows="9"
                max-rows="16"
                :required="form.questionType !== 'OPEN_ENDED'"
              ></b-form-textarea>
              <hr />
              <p id="solution"></p>
            </b-form-group>
            <b-form-group
              v-if="form.questionType === 'OPEN_ENDED'"
              id="input-group-ref"
              label="Respuesta de referencia / solución modelo"
              label-for="input-ref"
              description="No se muestra a los estudiantes. Se usa para calificar respuestas abiertas con IA."
            >
              <b-form-textarea
                id="input-ref"
                v-model="form.referenceAnswer"
                placeholder="Escriba la respuesta correcta de referencia"
                rows="5"
                max-rows="10"
                required
              ></b-form-textarea>
            </b-form-group>
            <br />

            <b-form-group
              id="input-group-1"
              label="Ayuda (píldora)"
              label-for="input-1"
              description="Vista previa con MathJax"
            >
              <b-form-textarea
                id="textarea"
                v-model="form.hint"
                placeholder=""
                rows="9"
                max-rows="16"
              ></b-form-textarea>
              <hr />
              <p id="hint"></p>
            </b-form-group>
            <br />

            <hr />
            <div class="row">
              <div class="col-12">
                <b-form-group
                  id="input-group-3"
                  label="Gráfica:"
                  label-for="imagen"
                >
                  <b-form-file
                    accept="image/jpeg, image/png, image/jpg, image/svg+xml"
                    id="graph"
                    v-on:change="handleFilesUpload($event)"
                    v-model="form.graphFiles"
                    :placeholder="
                      this.form.graphName
                        ? this.form.graphName
                        : 'Seleccione una imágen en formato PNG, JPG o SVG.'
                    "
                  ></b-form-file>
                  <div class="mt-3">
                    <b-img
                      v-if="
                        this.form.graphName &&
                        isWithoutExtension(this.form.graphName) &&
                        this.form.graphName.toString().length < 25
                      "
                      :src="getGraphUrl(this.form.graphName)"
                      fluid
                      alt="Graph"
                      style="
                        width: 350px;
                        margin-bottom: 25px;
                        margin-top: 10px;
                      "
                    ></b-img>
                    <b-img
                      v-else-if="this.form.graphName"
                      :src="this.form.graphName"
                      fluid
                      alt="Graph"
                      style="
                        width: 350px;
                        margin-bottom: 25px;
                        margin-top: 10px;
                      "
                    ></b-img>
                    <br />
                    <b-button
                      v-if="this.form.graphName"
                      variant="secondary"
                      @click="removeGrahp()"
                      >Eliminar gráfica</b-button
                    >
                  </div>
                </b-form-group>
              </div>
            </div>
            <hr />
            <template v-if="form.questionType !== 'OPEN_ENDED'">
            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta A"
              label-for="answer1input"
              description="Vista previa con MathJax"
            >
              <b-form-input
                id="answer1input"
                v-model="form.answer1"
                :required="form.questionType !== 'OPEN_ENDED'"
              ></b-form-input>
              <p id="answer1"></p>
              <div class="mt-2">
                <b-form-file size="sm" accept="image/jpeg, image/png, image/jpg, image/svg+xml" :id="'answerGraphFile1'" @change="handleAnswerGraphUpload($event, 1)" placeholder="Añadir gráfica a la opción A"></b-form-file>
                <template v-if="getAnswerGraphPreview(1)">
                  <b-img :src="getAnswerGraphPreview(1)" fluid alt="Opción A" class="mt-1" style="max-width: 120px;"></b-img>
                  <b-button size="sm" variant="outline-danger" class="mt-1" @click="removeAnswerGraph(1)">Quitar gráfica</b-button>
                </template>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta B"
              label-for="answer2input"
              description="Vista previa con MathJax"
            >
              <b-form-input
                id="answer2input"
                v-model="form.answer2"
                required
              ></b-form-input>
              <p id="answer2"></p>
              <div class="mt-2">
                <b-form-file size="sm" accept="image/jpeg, image/png, image/jpg, image/svg+xml" :id="'answerGraphFile2'" @change="handleAnswerGraphUpload($event, 2)" placeholder="Añadir gráfica a la opción B"></b-form-file>
                <template v-if="getAnswerGraphPreview(2)">
                  <b-img :src="getAnswerGraphPreview(2)" fluid alt="Opción B" class="mt-1" style="max-width: 120px;"></b-img>
                  <b-button size="sm" variant="outline-danger" class="mt-1" @click="removeAnswerGraph(2)">Quitar gráfica</b-button>
                </template>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta C"
              label-for="answer3input"
              description="Vista previa con MathJax"
            >
              <b-form-input
                id="answer3input"
                v-model="form.answer3"
              ></b-form-input>
              <p id="answer3"></p>
              <div class="mt-2">
                <b-form-file size="sm" accept="image/jpeg, image/png, image/jpg, image/svg+xml" :id="'answerGraphFile3'" @change="handleAnswerGraphUpload($event, 3)" placeholder="Añadir gráfica a la opción C"></b-form-file>
                <template v-if="getAnswerGraphPreview(3)">
                  <b-img :src="getAnswerGraphPreview(3)" fluid alt="Opción C" class="mt-1" style="max-width: 120px;"></b-img>
                  <b-button size="sm" variant="outline-danger" class="mt-1" @click="removeAnswerGraph(3)">Quitar gráfica</b-button>
                </template>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta D"
              label-for="answer4input"
              description="Vista previa con MathJax"
            >
              <b-form-input
                id="answer4input"
                v-model="form.answer4"
              ></b-form-input>
              <p id="answer4"></p>
              <div class="mt-2">
                <b-form-file size="sm" accept="image/jpeg, image/png, image/jpg, image/svg+xml" :id="'answerGraphFile4'" @change="handleAnswerGraphUpload($event, 4)" placeholder="Añadir gráfica a la opción D"></b-form-file>
                <template v-if="getAnswerGraphPreview(4)">
                  <b-img :src="getAnswerGraphPreview(4)" fluid alt="Opción D" class="mt-1" style="max-width: 120px;"></b-img>
                  <b-button size="sm" variant="outline-danger" class="mt-1" @click="removeAnswerGraph(4)">Quitar gráfica</b-button>
                </template>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta E"
              label-for="answer5input"
              description="Vista previa con MathJax"
            >
              <b-form-input
                id="answer5input"
                v-model="form.answer5"
              ></b-form-input>
              <p id="answer5"></p>
              <div class="mt-2">
                <b-form-file size="sm" accept="image/jpeg, image/png, image/jpg, image/svg+xml" :id="'answerGraphFile5'" @change="handleAnswerGraphUpload($event, 5)" placeholder="Añadir gráfica a la opción E"></b-form-file>
                <template v-if="getAnswerGraphPreview(5)">
                  <b-img :src="getAnswerGraphPreview(5)" fluid alt="Opción E" class="mt-1" style="max-width: 120px;"></b-img>
                  <b-button size="sm" variant="outline-danger" class="mt-1" @click="removeAnswerGraph(5)">Quitar gráfica</b-button>
                </template>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta F"
              label-for="answer6input"
              description="Vista previa con MathJax"
            >
              <b-form-input
                id="answer6input"
                v-model="form.answer6"
              ></b-form-input>
              <p id="answer6"></p>
              <div class="mt-2">
                <b-form-file size="sm" accept="image/jpeg, image/png, image/jpg, image/svg+xml" :id="'answerGraphFile6'" @change="handleAnswerGraphUpload($event, 6)" placeholder="Añadir gráfica a la opción F"></b-form-file>
                <template v-if="getAnswerGraphPreview(6)">
                  <b-img :src="getAnswerGraphPreview(6)" fluid alt="Opción F" class="mt-1" style="max-width: 120px;"></b-img>
                  <b-button size="sm" variant="outline-danger" class="mt-1" @click="removeAnswerGraph(6)">Quitar gráfica</b-button>
                </template>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="4"
              label-cols-lg="2"
              label="Respuesta Correcta"
              label-for="correctAnswer"
            >
              <b-form-radio-group
                v-model="form.correctAnswer"
                :options="form.options"
                id="correctAnswer"
                class="mb-10"
                :required="form.questionType !== 'OPEN_ENDED'"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>
            </b-form-group>
            </template>

            <b-alert 
              :show="form.showAlertErrorSec"
              variant="danger" 
              dismissible
              @dismissed="form.showAlertErrorSec=0"
            >
                Respuesta Correcta no válida
            </b-alert>

            <b-button type="submit" variant="primary">Guardar</b-button>

            <router-link
              :to="{
                name: 'QuestionsPreview',
                params: {
                  id: questionId ? questionId : 'create',
                  goBack: questionId ? questionId : 'create',
                  form: this.form,
                },
              }"
            >
              <b-button
                variant="primary"
                class="ml-3"
                :disabled="!isFormComplete"
              >
                <font-awesome-icon icon="fas fa-search-plus" />
                &nbsp;Vista previa
              </b-button>
            </router-link>
            <b-button
              type="submit"
              variant="primary"
              class="float-right"
              @click="this.exitQuestion"
              >Salir</b-button
            >
          </b-form>
        </div>
      </div>
    </div>

    <div>
      <b-modal id="modal-img" title="Gráfica Actual">
        <p class="my-3">
          <b-img
            :src="
              typeof form.graphUrl === 'undefined' || !form.graphUrl
                ? getGraphUrl(form.graph)
                : form.graphUrl
            "
            fluid-grow
            alt="Gráfica Actual"
          ></b-img>
        </p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";
import assetImport from "@/Utils/asset-import.js";

export default {
  props: ["formEdit"],
  data() {
    return {
      originalForm: "",
      form: {
        description: "",
        solution: "",
        hint: "",
        graph: "",
        graphName: "",
        graphUrl: "",
        graphFiles: [],
        uniqueName: "",
        position: "",
        competencies: null,
        difficulty: null,
        knowledgeArea: null,
        category: null,
        subcategory: null,
        answer1: "",
        answer2: "",
        answer3: "",
        answer4: "",
        answer5: "",
        answer6: "",
        answerGraph1: "",
        answerGraph2: "",
        answerGraph3: "",
        answerGraph4: "",
        answerGraph5: "",
        answerGraph6: "",
        answerGraphName1: "",
        answerGraphName2: "",
        answerGraphName3: "",
        answerGraphName4: "",
        answerGraphName5: "",
        answerGraphName6: "",
        answerGraphUrl1: "",
        answerGraphUrl2: "",
        answerGraphUrl3: "",
        answerGraphUrl4: "",
        answerGraphUrl5: "",
        answerGraphUrl6: "",
        correctAnswer: "A",
        questionType: "MULTIPLE_CHOICE",
        referenceAnswer: "",
        options: [
          { item: "A", name: "A" },
          { item: "B", name: "B" },
          { item: "C", name: "C" },
          { item: "D", name: "D" },
          { item: "E", name: "E" },
          { item: "F", name: "F" },
        ],
        showAlertErrorSec: 0,
      },
      questionTypeOptions: [
        { text: "Opción múltiple", value: "MULTIPLE_CHOICE" },
        { text: "Respuesta abierta", value: "OPEN_ENDED" },
      ],
      competencies: [],
      categories: [],
      tags: [],
      originalSimulacrum: "",
      originalPosition: "",
      simulacrumsResponse: [],
      categoriesResponse: [],
      practices: [],
      difficulties: [],
      modulesResponse: [],
      knowledge_areas: [],
      subcategories: [],
      searchTags: [],
      tagsitems: [],
      show: true,
      questionId: null,
      isEdit: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("from");
    console.log(from);
    console.log(next);
    if (from.name && from.name !== "QuestionsPreview")
      window.localStorage.removeItem("questionsListQuery");

    if (from.name === "QuestionsAdmin")
      window.localStorage.setItem("questionsListQuery", from.fullPath);
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "QuestionsPreview" &&
      JSON.stringify(this.originalForm) !== JSON.stringify(this.form)
    ) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else next();
  },
  methods: {
    loadTags() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL +
            "/api/tag/getTagsListforAdd/" +
            this.questionId,
          {
            params: {
              search: this.searchTags,
              modelName: "questions",
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.tagsitems = response.data;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    onModalHide() {
      this.tagsitems = [];
    },
    showModal1() {
      this.$refs["my-modal2"].show();
    },
    deleteTag(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este tag?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL +
            "/api/question/" +
            this.questionId +
            "/tags/" +
            id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    saveTag(tagId) {
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/question/saveTag",
          {
            questionId: this.questionId,
            tagId: tagId,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s("tag Guardado.");
          console.log(result);
          this.$router.go();
        })
        .catch((err) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e("Error al crear");
          console.log(err.message);
        });
    },
    createTag() {
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/tag/save",
          {
            name: this.searchTags,
            questionId: this.questionId,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s("tag Guardado y agregado.");
          console.log(result);
          this.$router.go();
        })
        .catch((err) => {
          if (err.message === "Request failed with status code 406") {
            this.$toastr.defaultTimeout = 5000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e("El ya existe, revisa los resultados de búsqueda");
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e("Error al crear");
          }
          console.log(err.message);
        });
    },
    exitQuestion() {
      if (window.localStorage.getItem("questionsListQuery")) {
        this.$router.push({
          path: window.localStorage.getItem("questionsListQuery"),
        });
      } else this.$router.push({ path: "/admin-panel/questions" });
    },
    getGraphUrl(graphName) {
      if (graphName === "NaN") return "";
      try {
        console.log(graphName);
        return require("../../../../assets/images/graphs/" +
          graphName +
          ".svg");
      } catch (e) {
        console.log("Gráfica no encontrada: " + graphName);
        return "";
      }
    },
    async loadCompetences() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/competences/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.competencies.push({
            text: "Selecciona una competencia",
            value: null,
          });
          for (let item of arr) {
            this.competencies.push({ text: item.description, value: item.id });
          }

          this.callEditService();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async loadDifficulty() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/difficulty/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.difficulties.push({
            text: "Selecciona una dificultad",
            value: null,
          });


          for (let item of arr.sort((a, b) => a.id - b.id)) {
            this.difficulties.push({ text: item.description, value: item.id });
          }

          this.loadCompetences();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    loadEditData() {
      this.loadCategories();
    },
    callEditService() {
      if (this.$route.params.id) {
        this.questionId = this.$route.params.id;
        this.isEdit = true;

        axios
          .get(
            import.meta.env.VITE_API_BASE_URL +
              "/api/question/" +
              this.questionId,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            this.loadEdit(response);
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        this.originalForm = JSON.parse(JSON.stringify(this.form));
        if (this.formEdit) {
          this.form = this.formEdit;
        }
      }
    },
    async loadEdit(response) {
      this.questionId = response.data.id;

      this.form.questionType = response.data.questionType || "MULTIPLE_CHOICE";
      this.form.referenceAnswer = response.data.referenceAnswer || "";

      let answersArr = (response.data.answers || []).sort(
        (a, b) => a.position - b.position
      );
      if (answersArr.length > 0) {
        this.form.correctAnswer = answersArr[0].correct
          ? "A"
          : answersArr[1] && answersArr[1].correct
          ? "B"
          : answersArr[2] && answersArr[2].correct
          ? "C"
          : answersArr[3] && answersArr[3].correct
          ? "D"
          : answersArr[4] && answersArr[4].correct
          ? "E"
          : answersArr[5] && answersArr[5].correct
          ? "F"
          : "A";
      }
      this.form.hint = response.data.hint;
      if (answersArr[0]) {
        this.form.answer1 = answersArr[0].description ? answersArr[0].description : "";
        this.form.answerGraphUrl1 = answersArr[0].graphUrl || "";
      }
      if (answersArr[1]) {
        this.form.answer2 = answersArr[1].description ? answersArr[1].description : "";
        this.form.answerGraphUrl2 = answersArr[1].graphUrl || "";
      }
      if (answersArr[2]) {
        this.form.answer3 = answersArr[2].description ? answersArr[2].description : "";
        this.form.answerGraphUrl3 = answersArr[2].graphUrl || "";
      }
      if (answersArr[3]) {
        this.form.answer4 = answersArr[3].description ? answersArr[3].description : "";
        this.form.answerGraphUrl4 = answersArr[3].graphUrl || "";
      }
      if (answersArr[4]) {
        this.form.answer5 = answersArr[4].description ? answersArr[4].description : "";
        this.form.answerGraphUrl5 = answersArr[4].graphUrl || "";
      }
      if (answersArr[5]) {
        this.form.answer6 = answersArr[5].description ? answersArr[5].description : "";
        this.form.answerGraphUrl6 = answersArr[5].graphUrl || "";
      }

      this.form.description = response.data.description;
      this.form.competencies = response.data.competence.id;
      this.form.knowledgeArea = response.data.knowledge_area.id;
      this.form.difficulty = response.data.difficulty.id;

      this.form.solution = response.data.solution;
      this.form.uniqueName = response.data.uniqueName;

      console.log(this.categoriesResponse)
      this.form.subcategory = response.data.subCategory.id;
      this.form.graphUrl = response.data.graphUrl;
      this.form.graph = response.data.graph;
      this.form.graphName = response.data.graphUrl
        ? response.data.graphUrl
        : response.data.graph;

      this.tags = response.data.tags;

      this.form.position = response.data.position;
      this.originalPosition = response.data.position;

      this.subcategories.push({text: 'Selecciona una subcategoría', value: null})

      for (let cat of this.categoriesResponse) {
        if (cat.subcategoryList) {
          for (let subcat of cat.subcategoryList) {
            if (subcat.id === this.form.subcategory) {
              this.form.category = cat.id;
              this.subcategories.push({text: 'Selecciona una subcategoría', value: null})
              for (let item of cat.subcategoryList) {
                if (item.deleted) {
                  continue;
                }
                this.subcategories.push({text: item.description, value: item.id})
              }
              this.form.subcategory = subcat.id;
            }
          }
        }

      }
      this.$nextTick(function () {
        this.originalForm = JSON.parse(JSON.stringify(this.form));
        if (this.formEdit) {
          this.form = this.formEdit;
        }
      });
    },
    async loadKnowledge() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/knowledgearea/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.knowledge_areas.push({
            text: "Selecciona un Tipo de pensamiento",
            value: null,
          });
          for (let item of arr) {
            this.knowledge_areas.push({
              text: item.description,
              value: item.id,
            });
          }
          this.loadDifficulty();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    isWithoutExtension(fileName) {
      const dotIndex = fileName.lastIndexOf(".");
      return (
        dotIndex === -1 || dotIndex === 0 || dotIndex === fileName.length - 1
      );
    },
    removeGrahp() {
      if (confirm("Estás seguro que deseas eliminar la gráfica?")) {
        this.form.graphName = null;
        this.form.graph = null;
        this.form.graphFiles = null;
        this.form.graphUrl = null;
      }
    },
    loadCategories() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/categories/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.categoriesResponse = arr
          this.categories.push({
            text: "Selecciona una categoría",
            value: null,
          });
          for (let item of arr) {
            if (item.deleted) {
              continue;
            }
            this.categories.push({ text: item.description, value: item.id });
          }

          this.loadKnowledge();
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    populateSelectSubcategories() {
      this.subcategories = [];
      if (this.form.category) {
        console.log(this.categoriesResponse);
        let relatedCategories = this.categoriesResponse.find(obj => obj.id === this.form.category).subcategoryList;
        this.subcategories.push({text: 'Selecciona una subcategoría', value: null})

        for (let item of relatedCategories) {
          if(item.deleted) {
            continue;
          }
          this.subcategories.push({text: item.description, value: item.id})
        }
      }
    },
    loadSubcategory() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/subcategory/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.subcategories.push({
            text: "Selecciona una subcategoría",
            value: null,
          });
          for (let item of arr) {
            if (item.deleted) {
              continue;
            }
            this.subcategories.push({ text: item.description, value: item.id });
          }

          this.loadKnowledge();
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    onSubmit(event) {
      event.preventDefault();

      if (
        this.form.questionType !== "OPEN_ENDED" &&
        !this.isCorrectAnswerValid()
      ) {
        this.form.showAlertErrorSec = 5;
        return;
      }

      if (this.isEdit) {
        let loader = this.$loading.show({});
        axios
          .put(
            import.meta.env.VITE_API_BASE_URL +
              "/api/question/edit/" +
              this.questionId,
            this.form,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((result) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.s("Pregunta Editada.");
            console.log(result);
            loader.hide();
            this.originalForm = JSON.parse(JSON.stringify(this.form));
            this.$nextTick(function () {
              router.push({
                path: `/admin-panel/questions/${this.questionId}`,
              });
              this.$router.go();
            });
          })
          .catch((err) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "No se puede asignar a este simulacro porque se encuentra visible"
            );
            console.log(err.message);
            loader.hide();
          });
      } else {
        let loader = this.$loading.show({});
        axios
          .post(
            import.meta.env.VITE_API_BASE_URL + "/api/question/save",
            this.form,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((result) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.s("Pregunta Guardada.");
            console.log(result);
            loader.hide();
            this.originalForm = JSON.parse(JSON.stringify(this.form));
            this.$nextTick(function () {
              router.push({ path: `/admin-panel/questions/${result.data.id}` });
              this.$router.go();
            });
          });
      }
    },
    isCorrectAnswerValid() {
      if (this.form.questionType === "OPEN_ENDED") return true;
      if (this.form.correctAnswer === "C" && !this.form.answer3) {
        return false;
      } else if (this.form.correctAnswer === "D" && !this.form.answer4) {
        return false;
      } else if (this.form.correctAnswer === "E" && !this.form.answer5) {
        return false;
      } else if (this.form.correctAnswer === "F" && !this.form.answer6) {
        return false;
      } else {
        return true;
      }
    },
    onReset(event) {
      event.preventDefault();
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    handleFilesUpload(e) {
      const file = e.target.files[0];
      console.log(file);
      this.form.graphName = URL.createObjectURL(file);
      this.getBase64(file).then((data) => (this.form.graph = data));
    },
    getAnswerGraphPreview(n) {
      const url = this.form["answerGraphUrl" + n];
      const name = this.form["answerGraphName" + n];
      if (url) return url;
      if (name) return name;
      return null;
    },
    handleAnswerGraphUpload(e, n) {
      const file = e.target && e.target.files && e.target.files[0];
      if (!file) return;
      this.form["answerGraphName" + n] = URL.createObjectURL(file);
      this.getBase64(file).then((data) => (this.form["answerGraph" + n] = data));
      e.target.value = "";
    },
    removeAnswerGraph(n) {
      this.form["answerGraph" + n] = "";
      this.form["answerGraphName" + n] = "";
      this.form["answerGraphUrl" + n] = "";
    },
  },
  computed: {
    isFormComplete() {
      const base =
        this.form.description &&
        this.form.subcategory &&
        this.form.competencies &&
        this.form.difficulty;
      if (this.form.questionType === "OPEN_ENDED") {
        return base && this.form.referenceAnswer;
      }
      return (
        base &&
        this.form.answer1 &&
        this.form.answer2 &&
        this.form.answer3 &&
        this.form.answer4 &&
        this.form.solution &&
        this.form.correctAnswer
      );
    },
  },
  watch: {
    "form.description": function () {
      const elements = document.getElementById("description");
      if (elements) {
        elements.innerText = this.form.description;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.solution": function () {
      const elements = document.getElementById("solution");
      if (elements) {
        elements.innerText = this.form.solution;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.hint": function () {
      const elements = document.getElementById("hint");
      if (elements) {
        elements.innerText = this.form.hint;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.answer1": function () {
      const elements = document.getElementById("answer1");
      if (elements) {
        elements.innerText = this.form.answer1;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.answer2": function () {
      const elements = document.getElementById("answer2");
      if (elements) {
        elements.innerText = this.form.answer2;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.answer3": function () {
      const elements = document.getElementById("answer3");
      if (elements) {
        elements.innerText = this.form.answer3;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.answer4": function () {
      const elements = document.getElementById("answer4");
      if (elements) {
        elements.innerText = this.form.answer4;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.answer5": function () {
      const elements = document.getElementById("answer5");
      if (elements) {
        elements.innerText = this.form.answer5;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    "form.answer6": function () {
      const elements = document.getElementById("answer6");
      if (elements) {
        elements.innerText = this.form.answer6;
      }
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    'form.category'() {
      this.populateSelectSubcategories();
    },
  },

  mounted() {
    this.loadEditData();

    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();

    window.MathJax.Hub.Config({
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"],
        ],
      },
    });
  },
};
</script>
